
export class MicroappFbsOwnerModel {
    firstName: string;
    lastName: string;
    emailAddress: string;
    userId:number;
    tenant_name:string;
}